<div class="flex flex-col gap-1">

  <label class="kt-form-label font-medium text-xs mb-1">

    {{ field.label }}

  </label>

  <sw-dynamic-autocomplete

    [config]="field"

    [placeholder]="
      field.placeholder || ''
    "

    [api]="
      field.dataSource?.api || ''
    "

    [valueField]="
      field.dataSource?.valueField || 'id'
    "

    [labelField]="
      field.dataSource?.labelField || 'name'
    "

    [minLength]="
      field.dataSource?.minLength || 2
    "

    [dependsOn]="
      field.dependsOn || []
    "

    [parentForm]="
      form
    "

    [ngModel]="control?.value"

    (ngModelChange)="
      control?.setValue($event)
    "

    [ngModelOptions]="{
      standalone: true
    }">

  </sw-dynamic-autocomplete>

  <mat-error *ngIf="isInvalid">

    {{ getError() }}

  </mat-error>

</div>